var c;
((e) => {
  const o = /* @__PURE__ */ new Map();
  let r = "unset";
  const t = (n) => {
    r = n, window.fbq && window.fbq("consent", n);
  };
  function f() {
    t("grant");
  }
  e.grantConsent = f;
  function l() {
    t("revoke");
  }
  e.revokeConsent = l;
  async function u(n) {
    const s = o.get(n);
    if (s)
      return s;
    const a = (async () => {
      const i = await import("react-facebook-pixel");
      i.default.init(n), r === "revoke" && t("revoke"), i.default.pageView();
    })();
    return o.set(n, a), a;
  }
  e.loadPixel = u;
})(c || (c = {}));
export {
  c as FacebookAnalytics
};
//# sourceMappingURL=index.js.map
